module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-social-banners-1200x630-5b3cc89bb93adfc8ae2afb796085b0cb.jpg";